export const accountKeys = {
  all: ["accounts"] as const,
  lists: () => [...accountKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...accountKeys.lists(), filters] as const,
  counts: (filters: Record<string, unknown>) => [...accountKeys.all, "counts", filters] as const,
  details: () => [...accountKeys.all, "detail"] as const,
  detail: (id: string) => [...accountKeys.details(), id] as const,
  related: (id: string) => [...accountKeys.all, "related", id] as const,
};
